import React, { Component, MouseEvent, ChangeEvent } from 'react'
import { Product as ProductPb } from '../../rpc/admin/products_pb';

interface ColorAttributeProps {
    label: string;
    value: ProductPb.Variant.AttributeValuePair;
    disabled?: boolean;
    onChange?: (value: ProductPb.Variant.AttributeValuePair) => void;
}

interface ColorAttributeState {
    open: boolean;
    name: string;
    hex: string;
    nameError: string;
    hexError: string;
}

class ColorAttribute extends Component<ColorAttributeProps, ColorAttributeState> {

    constructor(props: ColorAttributeProps) {
        super(props);
        this.state = {
            open: false,
            name: '',
            hex: '',
            nameError: '',
            hexError: ''
        };
    }

    private handleKeyDown = (e: KeyboardEvent): any => {
        if (e.key === 'Escape') {
            this.cancel();
        } else if (e.key === 'Enter') {
            this.ok();
        }
    }

    private handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            name: e.target.value
        });
    }

    private handleHexChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            hex: e.target.value
        });
    }

    private handleInputClick = (e: MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!this.state.open) {
            window.addEventListener('keydown', this.handleKeyDown);
            let hex = this.props.value.getColorPicker()?.getHex();
            if (!hex) {
                hex = '000';
            }
            this.setState({
                open: true,
                name: this.props.value.getValue(),
                hex: hex,
                nameError: '',
                hexError: ''
            });
        }
    }

    private handleOkClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.ok();
    }

    private handleCancelClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.cancel();
    }

    private handleSwatchClick = (e: MouseEvent<HTMLDivElement>, name: string) => {
        e.preventDefault();
        switch (name) {
            case 'Black':
                this.setState({
                    name: 'Black',
                    hex: '000000'
                });
                break;
            case 'White':
                this.setState({
                    name: 'White',
                    hex: 'ffffff'
                });
                break;
            case 'FDE':
                this.setState({
                    name: 'FDE',
                    hex: '8b755d'
                });
                break;
            case 'OD Green':
                this.setState({
                    name: 'OD Green',
                    hex: '5e644c'
                });
                break;
        }
    }

    private ok = () => {
        const name = this.state.name.trim();
        const hex = this.state.hex.trim();
        let nameError = '', hexError = '';
        if (!name) {
            nameError = 'Color name is required';
        }
        if (!/^([0-9A-Fa-f]{3}){1,2}$/i.test(hex)) {
            hexError = 'Invalid hex color value';
        }
        if (hexError || nameError) {
            this.setState({
                hexError: hexError,
                nameError: nameError
            });
            return;
        }

        window.removeEventListener('keydown', this.handleKeyDown);

        this.setState({
            open: false
        });

        if (this.props.onChange) {
            const avp = this.props.value.clone();
            avp.setValue(name);
            const cp = new ProductPb.Variant.AttributeValuePair.ColorPicker();
            cp.setHex(hex);
            avp.setColorPicker(cp);
            this.props.onChange(avp)
        }
    }

    private cancel = () => {
        window.removeEventListener('keydown', this.handleKeyDown);

        this.setState({
            open: false
        });
    }

    render() {
        let color = this.props.value.getColorPicker()?.getHex();
        if (!color) {
            color = '000';
        }
        return (
            <>
                <div className="field">
                    <label className="label">{this.props.label}</label>
                    <div className="control">
                        <div className="input color-input"
                            onClick={this.handleInputClick}
                            style={{backgroundColor: '#' + color}}><span>{this.props.value.getValue()}</span></div>
                    </div>
                </div>
                {
                    this.state.open && (
                        <div className="modal is-active">
                            <div className="modal-background"></div>
                                <div className="color-modal">
                                    <div className="color-sample" style={{backgroundColor: '#' + this.state.hex}}></div>
                                    <div className="color-swatches">
                                        <div className="color-swatch-black"
                                            title="Black"
                                            onClick={(e: MouseEvent<HTMLDivElement>) => this.handleSwatchClick(e, 'Black')} />
                                        <div className="color-swatch-white"
                                            title="White"
                                            onClick={(e: MouseEvent<HTMLDivElement>) => this.handleSwatchClick(e, 'White')} />
                                        <div className="color-swatch-fde"
                                            title="FDE"
                                            onClick={(e: MouseEvent<HTMLDivElement>) => this.handleSwatchClick(e, 'FDE')} />
                                        <div className="color-swatch-od-green"
                                            title="OD Green"
                                            onClick={(e: MouseEvent<HTMLDivElement>) => this.handleSwatchClick(e, 'OD Green')} />
                                    </div>
                                    <div className="color-modal-controls">
                                        <div className="field">
                                            <label className="label">Color Name</label>
                                            <div className="control">
                                                <input className={"input" + (this.state.nameError ? " is-danger" : "")}
                                                    autoFocus={true}
                                                    autoComplete="off"
                                                    onChange={this.handleNameChange}
                                                    type="text"
                                                    disabled={this.props.disabled}
                                                    value={this.state.name} />
                                            </div>
                                            { this.state.nameError &&
                                                <p className="help is-danger">{this.state.nameError}</p>
                                            }
                                        </div>

                                        <div className="field">
                                            <label className="label">Hex</label>
                                            <div className="control">
                                                <input className={"input" + (this.state.hexError ? " is-danger" : "")}
                                                    autoComplete="off"
                                                    onChange={this.handleHexChange}
                                                    type="text"
                                                    disabled={this.props.disabled}
                                                    value={this.state.hex} />
                                            </div>
                                            { this.state.hexError &&
                                                <p className="help is-danger">{this.state.hexError}</p>
                                            }
                                        </div>

                                        <button className="button is-success" onClick={this.handleOkClick}>OK</button>
                                        <button className="button" onClick={this.handleCancelClick}>Cancel</button>
                                    </div>
                                </div>
                        </div>
                    )
                }
            </>
        );
    }
}

export default ColorAttribute;
